<template>
  <Dropdown placement="top-left">
    <template #trigger>
      <div class="tweaks__item">
        <i class="bi bi-moon"></i>
        <span>{{ $t('app.sidebar.theme.title') }}</span>
      </div>
    </template>
    <template #menu="{ close }">
      <div class="dropdown__menu">
        <div class="dropdown__item" @click="close(); isDark = true">
          <i class="bi bi-moon"></i>
          <span>{{ $t('app.sidebar.theme.dark') }}</span>
        </div>
        <div class="dropdown__item" @click="close(); isDark = false">
          <i class="bi bi-sun"></i>
          <span>{{ $t('app.sidebar.theme.light') }}</span>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import { useDark } from '@vueuse/core';
import Dropdown from '@/components/global/Dropdown.vue';

const isDark = useDark();
</script>